/** Кусок байтов from..to (включительно) файла размером size: заголовок Content-Range */
export class ChunkParams {
  from: number
  to: number
  size: number

  constructor({ from, to, size }: { from: number, to: number, size: number }) {
    this.from = from
    this.to = to
    this.size = size
  }
}
